module.exports = __webpack_public_path__ + "static/lato-latin-300italic.424b0e5d.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-lato/files/lato-latin-300italic.woff
// module id = ./node_modules/typeface-lato/files/lato-latin-300italic.woff
// module chunks = 17241999800008180000